var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.step < _vm.config.steps
        ? _c(
            "el-button",
            {
              attrs: { disabled: _vm.campaign_ended },
              on: { click: _vm.handleProceed },
            },
            [_vm._v("\n    " + _vm._s(_vm.text || "Proceed") + " \n  ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }